import { useTranslation } from 'react-i18next';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { ApiError } from '../../../../Shared/interfaces/ApiError';
import { ApiResponseKeys } from '../../../../Shared/interfaces/ApiResponse';
import useApiClient from '../../../../Shared/services/api';
import { useAppContext } from '../../../../Shared/store/appContext';
import { EndpointQueryKeys } from '../../../constants/endpoints';
import { restoreBooking } from '../services/service';
import { QueueSheetManagementRows } from '../interface/QueueSheetInterface';

export const useRestoreBookingMutation = (
    setIsRestoreModalOpen: React.Dispatch<React.SetStateAction<boolean>>,
    setBookingToRestore: React.Dispatch<
        React.SetStateAction<QueueSheetManagementRows | null>
    >,
    setSuccessMessage: React.Dispatch<React.SetStateAction<string | null>>,
    setCurrentPage: React.Dispatch<React.SetStateAction<number>>
) => {
    const { t } = useTranslation();
    const api = useApiClient();
    const queryClient = useQueryClient();
    const {
        state: { selectedArtEventId },
    } = useAppContext();
    const artEventId = selectedArtEventId ?? '';

    return useMutation<ApiResponseKeys, ApiError, string>({
        mutationFn: (bookingId: string) => restoreBooking(api, bookingId),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: [EndpointQueryKeys.GET_BOOKING_SHEET, artEventId],
            });
            setCurrentPage(0);
            setIsRestoreModalOpen(false);
            setBookingToRestore(null);
            setSuccessMessage(t('restore-booking-success-message'));
        },
    });
};
